import { type ColumnDef } from "@tanstack/react-table";

import { DataTable } from "@/components/ui/data-table";
import type { PayoutHistoryItem } from "@/types/affiliate-dashboard";
import { formatCurrency } from "@/utils/currency";
import { DashboardCard, StatusText } from "@/components/dashboard/dashboard-card";
import { shortDate } from "./helpers";

const columns: ColumnDef<PayoutHistoryItem>[] = [
  {
    accessorKey: "amount",
    header: "Amount",
    meta: { width: "w-24" },
    cell: ({ row }) => (
      <span className="font-medium tabular-nums text-foreground">{formatCurrency(row.original.amount)}</span>
    ),
  },
  {
    accessorKey: "status",
    header: "Status",
    meta: { width: "w-24" },
    cell: ({ row }) => <StatusText status={row.original.status} />,
  },
  {
    accessorKey: "createdAt",
    header: "Requested",
    meta: { width: "w-24" },
    cell: ({ row }) => (
      <span className="whitespace-nowrap text-muted-foreground">{shortDate(row.original.createdAt)}</span>
    ),
  },
];

export function PayoutsCard({ data, isLoading }: { data: PayoutHistoryItem[] | undefined; isLoading: boolean }) {
  return (
    <DashboardCard
      id="dashboard-payouts-card"
      title="Recent payouts"
      to="/affiliate/payouts/history"
      bodyClassName="px-3 pb-3"
    >
      <DataTable
        columns={columns}
        data={data ?? []}
        isLoading={isLoading}
        skeletonRows={3}
        getRowId={(row) => row.id}
        emptyText="No payouts yet"
        minTableWidth="min-w-0"
      />
    </DashboardCard>
  );
}
